import React from 'react'

function ArrowRight() {
  return (
    <div className="pl-2">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M13 7l5 5m0 0l-5 5m5-5H6" />
      </svg>
    </div>
  )
}

export default ArrowRight;
